import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { PublisherModerationSettingsAction } from '../../domains/publisherModerationSettings/actions.types';

import type { PublisherModerationSettings } from './types';

const initialState: PublisherModerationSettings = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<PublisherModerationSettings, PublisherModerationSettingsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'PUBLISHER.MODERATION_SETTINGS_PENDING':
      return setPending();
    case 'PUBLISHER.MODERATION_SETTINGS_FULFILLED':
      return setFulfilled(action.payload);
    case 'PUBLISHER.MODERATION_SETTINGS_REJECTED':
      return setRejected(action.payload.error);

    default:
      return state;
  }
};

export default reducer;
